/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Explore_TitleInputs */

const en_directory_footer_explore_title = /** @type {(inputs: Directory_Footer_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const zh_directory_footer_explore_title = /** @type {(inputs: Directory_Footer_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Directory_Footer_Explore_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_explore_title = /** @type {((inputs?: Directory_Footer_Explore_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Explore_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_explore_title(inputs)
	return zh_directory_footer_explore_title(inputs)
});
export { directory_footer_explore_title as "directory.footer.explore_title" }